import store from '../../store'

export default function loadPage(to) {
  let pageId

  for(let i = to.matched.length - 1; i > 0; i--) {
    if(to.matched[i].meta.pageId) {
      pageId = to.matched[i].meta.pageId
      break;
    }
  }

  if(pageId) {
    store.dispatch('page/load', pageId)
  } else {
    store.commit('page/reset')
  }
}
